import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logo/iknowa-logo-v4.svg'


const _withScopeId = n => (_pushScopeId("data-v-7afe7dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onbording-wrap" }
const _hoisted_2 = { class: "onbording-wrap__inner big" }
const _hoisted_3 = { class: "back-button" }
const _hoisted_4 = { class: "onboarding__modal tw-flex tw-flex-col tw-justify-between" }
const _hoisted_5 = { class: "onboarding-steps-header" }
const _hoisted_6 = { class: "onboarding-steps-header__inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-steps-header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "160",
    height: "29",
    class: "open-logo",
    src: _imports_0
  })
], -1))
const _hoisted_8 = { class: "onboarding-steps-header__title" }
const _hoisted_9 = {
  key: 0,
  class: "s540:!tw-text-[22px]"
}
const _hoisted_10 = {
  key: 1,
  class: "s540:!tw-text-[22px]"
}
const _hoisted_11 = { class: "onboarding-steps-content tw-h-full tw-bg-white" }
const _hoisted_12 = { class: "onboarding-steps-content__inner tw-h-full rmd:!tw-h-auto" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-steps-content__text" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "s540:!tw-text-[18px]" }, "Upload your Profile Image"),
  /*#__PURE__*/_createElementVNode("p", { class: "s540:!tw-text-[14px] s540:!tw-leading-[18px]" }, " Please select or capture an image to be uploaded ")
], -1))
const _hoisted_15 = { class: "onboarding-steps-content__upload tw-gap-[30px] s540:!tw-gap-[0rem] s540:!tw-mb-0 !tw-mb-0" }
const _hoisted_16 = { class: "uploade-wrapper s540:!tw-my-4 s540:!tw-mx-auto s540:!tw-w-full s540:!tw-h-full s540:tw-flex s540:tw-flex-col s540:tw-items-center s540:tw-mb-0" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "next_step_btns tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3" }
const _hoisted_19 = {
  key: 1,
  class: "tw-h-full"
}
const _hoisted_20 = { class: "tw-h-full" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-steps-content__text" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "s540:!tw-text-[18px]" }, "Add Your Phone Number"),
  /*#__PURE__*/_createElementVNode("p", { class: "s540:!tw-text-[14px] s540:!tw-leading-[18px]" }, " Be the first to receive special offers & benefits from iknowa ")
], -1))
const _hoisted_22 = { class: "contact_form tw-h-[calc(100%-70px)]" }
const _hoisted_23 = { class: "contact__field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Phone Number", -1))
const _hoisted_25 = { class: "contact_input" }
const _hoisted_26 = { class: "tw-min-w-[300px] rmd:tw-min-w-[360px] !tw-w-full" }
const _hoisted_27 = { class: "contact_input_code" }
const _hoisted_28 = { class: "tw-w-full tw-px-4 tw-py-5 rmd:tw-px-20 rmd:tw-pt-4 rmd:tw-pb-5 tw-rounded-b-[30px] tw-bg-white" }

import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
// import { UKPhoneValidationSchema } from "../../../core/validation/validation";
import { countryinfo } from "../../../core/utils/countryinfo";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import CommonLoader from "@/core/components/CommonLoader.vue";
import Text from "@/core/components/ui/general/Text.vue";
import { watch } from "vue";
import { isValidPhoneNumber } from "libphonenumber-js";
import { COURSES_STORE } from "@/store/modules/courses";
import { DASHBOARD_ROUTE } from "@/modules/dashboard/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecilalismsPage',
  setup(__props) {

const router = useRouter();
const store = useStore();
const route = useRoute();

const loading = ref(false);
const showProfile = ref(true);
const showPhone = ref(false);
const showSearchSpecialism = ref(false);
const imageUrl = ref("");
const listOfSpecialism = ref([]) as any;
const filteredCategories = ref([]) as any;
const listOfCategories = ref([]);
const selectedItems = ref([]) as any;
const countryCode = ref(null) as any;
const formRef = ref(null) as any;
const userPhone = ref("");
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const isSpecialismContinueLoading = ref(false);
const savingDetails = ref(false);
const validation = ref({
  phone: [
    (v: string) => !!v || "Phone number is required",
    (v: string) =>
      /^\+\d{1,3}\s?/.test(countryCode.value + v) ||
      "Please select country code.",
    (v: string) => {
      const countryCodeVal: any = countryinfo.find(
        (country: any) => country.dial_code === countryCode.value
      )?.code;
      const phoneNumber = isValidPhoneNumber(v, countryCodeVal);
      return phoneNumber || "Invalid Phone Number";
    },
  ],
});
const fileUploadErrorMsg = ref("");

const isPhoneValid = computed(() => {
  return validation.value.phone.every((rule) => rule(userPhone.value) === true);
});

// Function to handle selection change event
const handleSelectionChange = (selectedItemID: any) => {
  const index = selectedItems.value.findIndex(
    (item: any) => item.id === selectedItemID
  );
  let selectedItem: any = listOfCategories.value.find(
    (item: any) => item.id === selectedItemID
  );
  if (!selectedItem) {
    return;
  }
  if (index !== -1) {
    selectedItems.value.splice(index, 1); // Remove the item if it exists
  } else {
    selectedItem.selected = true;
    selectedItems.value.push(selectedItem); // Push the selected item object into the selectedItems array
  }
  selectedItemsCategory.value = selectedItems.value.filter(
    (specialism: any) => specialism.selected
  );
  hasSelectedSpecialism.value = selectedItems.value.length > 0; // Check if there are any selected items
};

onMounted(async () => {
  getData();
  countryCode.value = countryinfo.find(
    (country: any) => country.code === "GB"
  )?.dial_code;
  // userPhone.value = countryCode.value + " " + userPhone.value;
});

const getData = async () => {
  try {
    loading.value = true;
    let response = await store.dispatch(`${USER_STORE}/getCategories`);
    listOfCategories.value = response;
    const popularCategories = [1, 2, 4, 13, 8, 41];

    filteredCategories.value = response.filter((category: any) =>
      popularCategories.includes(category.id)
    );
  } catch (error) {
    console.log("error:", error);
  } finally {
    loading.value = false;
  }
};
let step = ref(0);
const selectedItemsCategory = ref([]);

const toggleSelection = (index: number) => {
  const specialism = filteredCategories.value[index];
  if (!("selected" in specialism)) {
    specialism.selected = true; // If 'selected' key is not present, add it and set to true
    hasSelectedSpecialism.value = true;
  } else {
    specialism.selected = !specialism.selected; // Toggle 'selected' value
    // hasSelectedSpecialism.value = false;
  }
  selectedItemsCategory.value = filteredCategories.value.filter(
    (specialism: any) => specialism.selected
  );
};

const handleCountryCode = () => {
  if (userPhone.value) {
    userPhone.value = "";
  }
  // userPhone.value = countryCode.value + " " + userPhone.value;
};

const hasSelectedSpecialism = ref(false);

const goToFirstStep = () => {
  step.value = 0; // Change to the first step
  showProfile.value = false;
  clearSpecialism();
};

// const goToNextStep = async () => {
//   try {
//     isSpecialismContinueLoading.value = true;
//     const subCategoryId = selectedItemsCategory.value.map((item: any) => {
//       return Number(item.subCategories[0].id);
//     });

//     await store.dispatch(`${USER_STORE}/saveUserSkills`, {
//       userId: user.value?.id,
//       subCategoryId: subCategoryId,
//     });

//     step.value = 1; // Change to the next step
//     showProfile.value = true;
//   } catch (error) {
//     console.log("error:", error);
//   } finally {
//     isSpecialismContinueLoading.value = false;
//   }
// };
let imageData = ref("");
const isImageUpload = ref(false);

const goToLastStep = async (e: any, skip = false) => {
  e.preventDefault();
  if (skip) {
    clearImageUrl();
    isImageUpload.value = true;
    step.value = 1;
    showPhone.value = true;
    showProfile.value = false;

    try {
      await store.dispatch(`${USER_STORE}/saveUserProfile`, {
        userId: user.value.id,
        profile: {
          profileImage: null,
        },
      });
    } catch (error) {
      isImageUpload.value = false;
    } finally {
      isImageUpload.value = false;
    }
    return;
  }
  if (!imageData.value) return;
  step.value = 1; // Change to the next step
  try {
    isImageUpload.value = true;
    if (imageData.value) {
      const formData = new FormData();
      formData.append("file", imageData.value);
      const response = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );
      await store.dispatch(`${USER_STORE}/saveUserProfile`, {
        userId: user.value.id,
        profile: {
          profileImage: response?.attachment,
        },
      });
      await store.dispatch(`${USER_STORE}/saveUserImage`, response?.publicUrl);
      clearImageUrl();
    }
    showPhone.value = true;
    showProfile.value = false;
  } catch (error: any) {
    console.log("");
    isImageUpload.value = false;
    fileUploadErrorMsg.value = error?.response?.data?.message;
  } finally {
    isImageUpload.value = false;
  }
};

const clearSpecialism = () => {
  listOfSpecialism.value = [];
  getData();
  selectedItems.value = [];
  hasSelectedSpecialism.value = false;
};

const skipProfileImage = () => {
  step.value = 2;
  showPhone.value = true;
  showProfile.value = false;
};
const onFileChange = async (event: any) => {
  fileUploadErrorMsg.value = "";
  const fileInput = event.target;
  if (fileInput.files && fileInput.files.length > 0) {
    const file = fileInput.files[0];
    if (
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg"
    ) {
      imageUrl.value = URL.createObjectURL(file);
      imageData.value = file;
    }
  } else {
    console.error("Error: No file selected.");
  }
};

const searchForSpecialisms = () => {
  showSearchSpecialism.value = true;
};
const onReserveSpot = async (courseId: any, selectedDates: any) => {
  // gather required data
  const userId = user.value.id;
  const courseReserveData = selectedDates.map((date: any) => {
    return {
      courseId: parseInt(courseId, 10),
      courseScheduleId: date.id,
      selectedSpotCount: date.spots,
    };
  });

  console.log(courseReserveData, "courseReserveData in login");
  const request = {
    userId,
    courseReserveData,
  };
  console.log(request, "request in login");

  // reserve spot
  try {
    const response = await store.dispatch(
      `${COURSES_STORE}/reserveSpot`,
      request
    );
    if (response && response.length) {
      // Navigate to course details page
      router.push({
        name: "courseDetails",
        params: {
          courseId: courseId,
          variableName: "course",
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const goToDashboard = async () => {
  const isFormValid = await formRef.value.validate();
  if (!isFormValid.valid) return;
  let courseReservation = null;
  if (route.query.courseReservation) {
    courseReservation = JSON.parse(
      String(route.query.courseReservation) || "{}"
    );
  } else {
    console.log("no route");
  }
  try {
    //upload user image

    //save phone number
    savingDetails.value = true;
    // await store.dispatch(`${USER_STORE}/verifyPhoneNumber`, {
    //   contactNo: userPhone.value,
    // });
    await store.dispatch(`${USER_STORE}/updateUser`, {
      userId: user.value?.id,
      userData: {
        hasAccountSetup: true,
        contactNo: `${countryCode.value} ${userPhone.value}`,
      },
    });
    await store.dispatch(
      `${USER_STORE}/saveUserRole`,
      UserRolesEnum.TRADESPERSON
    );

    if (courseReservation) {
      // onReserveSpot(
      //   courseReservation.courseId,
      //   courseReservation.selectedDates
      // );
      router.push({
        name: DASHBOARD_ROUTE,
        query: {
          courseReservation: JSON.stringify(courseReservation),
        },
      });
    } else {
      router.push("/dashboard");
    }
  } catch (error) {
    console.log();
  } finally {
    savingDetails.value = false;
  }
};

const backToPrevious = () => {
  if (step.value == 0) {
    router.push("/onboarding");
  } else if (step.value == 1) {
    showProfile.value = true;
    showPhone.value = false;
    step.value = 0;
  }
  // else if (step.value == 2) {
  //   showProfile.value = true;
  //   showPhone.value = false;
  //   step.value = 1;
  // }
};

const isContinueDisabled = computed(() => {
  return !imageUrl.value || isImageUpload.value;
});
const clearImageUrl = () => {
  imageUrl.value = "";
};

watch(
  () => listOfSpecialism.value,
  async (newValue, oldValue) => {
    if (newValue) {
      handleSelectionChange(newValue);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_flag = _resolveComponent("flag")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_btn, {
          variant: "text",
          "aria-label": "Refresh",
          class: "back-button",
          "prepend-icon": "mdi-chevron-left",
          onClick: backToPrevious
        }, {
          default: _withCtx(() => [
            _createTextVNode("back")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (showProfile.value)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_9, " Profile Image "))
                : _createCommentVNode("", true),
              (showPhone.value)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_10, " Phone Number "))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (showProfile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file s540:!tw-w-[150px] s540:!tw-h-[150px] s540:!tw-m-0 s540:!tw-overflow-hidden", { 'added-img': imageUrl.value }]),
                        "append-inner-icon": "mdi-image-plus",
                        accept: "image/png, image/jpeg",
                        variant: "solo-filled",
                        onChange: onFileChange,
                        "onClick:clear": clearImageUrl
                      }, null, 8, ["class"]),
                      _createVNode(_component_v_img, {
                        class: "uploaded-img s540:!tw-w-[150px] s540:!tw-h-[150px] s540:!tw-left-[unset]",
                        width: 200,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: imageUrl.value
                      }, null, 8, ["src"]),
                      _createVNode(Text, {
                        variant: "p",
                        textAlign: "center",
                        textColor: "rgba(255, 0, 0,0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(fileUploadErrorMsg.value), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_17,
                      _createVNode(Text, {
                        variant: "span",
                        textAlign: "center",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Accepted file formats: PNG, JPEG")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_v_btn, {
                        class: "button button-orange w-full traking",
                        disabled: isContinueDisabled.value,
                        loading: isImageUpload.value,
                        onClick: goToLastStep
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" continue ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"]),
                      _createVNode(Text, {
                        variant: "p",
                        textWeight: "500",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("No Image? "),
                          _createVNode(Text, {
                            class: "tw-cursor-pointer",
                            variant: "p",
                            textWeight: "500",
                            textColor: "#FFA500",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToLastStep($event, true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Skip for now "),
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chevron-right",
                                color: "#FFA500"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (showPhone.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_v_form, {
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                        rules: validation.value,
                        ref_key: "formRef",
                        ref: formRef,
                        class: "tw-gap-8"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_v_autocomplete, {
                                modelValue: countryCode.value,
                                "onUpdate:modelValue": [
                                  _cache[1] || (_cache[1] = ($event: any) => ((countryCode).value = $event)),
                                  handleCountryCode
                                ],
                                items: _unref(countryinfo),
                                "item-title": "name",
                                "item-value": "dial_code",
                                class: "flag-selector input_field",
                                rounded: "",
                                outlined: "false"
                              }, {
                                chip: _withCtx(({ props, item }) => [
                                  _createVNode(_component_flag, _mergeProps(props, {
                                    style: {"font-size":"14px","width":"100%"},
                                    iso: item.raw.code
                                  }), null, 16, ["iso"])
                                ]),
                                item: _withCtx(({ props, item }) => [
                                  _createElementVNode("div", _hoisted_26, [
                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                      title: item.raw.name,
                                      class: "country__selector tw-w-full"
                                    }), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_flag, _mergeProps(props, {
                                          style: {"font-size":"16px"},
                                          iso: item.raw.code
                                        }), null, 16, ["iso"])
                                      ]),
                                      _: 2
                                    }, 1040, ["title"])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "items"]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("p", null, _toDisplayString(countryCode.value), 1)
                              ]),
                              _createVNode(_component_v_text_field, {
                                class: "input",
                                type: "text",
                                density: "compact",
                                placeholder: "Phone Number",
                                variant: "solo-filled",
                                rules: validation.value.phone,
                                modelValue: userPhone.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userPhone).value = $event))
                              }, null, 8, ["rules", "modelValue"])
                            ])
                          ]),
                          _createVNode(_component_v_btn, {
                            class: "button button-orange w-full",
                            loading: savingDetails.value,
                            disabled: !isPhoneValid.value,
                            onClick: goToDashboard
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" complete onboarding ")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_v_stepper, {
            modelValue: _unref(step),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(step) ? (step).value = $event : step = $event)),
            class: "onboard-stepper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_stepper_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_stepper_item, {
                    class: _normalizeClass({ done: _unref(step) > 0 }),
                    title: "Profile Image",
                    value: "2"
                  }, null, 8, ["class"]),
                  _createVNode(_component_v_stepper_item, {
                    title: "Phone",
                    value: "3"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})